<div class="divider" [ngStyle]="control.style || false">
  <mat-list-item class="text" *ngIf="control.text">{{control.translatePrefixLabel + '.' + control.text | translate}}</mat-list-item>
  <mat-divider></mat-divider>
</div>
